import { createApp, h } from 'vue';
import I18nVuePlugin from '~/i18n/vue_plugin';

import Input from './components/input.vue';

export function setupSignUpPasswordInput() {
  const el = document.querySelector('.js-sign-up-password-input');

  if (!el) return null;

  const { id, name, label } = el.dataset;

  const app = createApp(
    {
      render: () => h(Input)
    },
    {
      id,
      name,
      label
    }
  );

  app.use(I18nVuePlugin);
  app.mount(el);
}
